// Cotizar por WhatsApp (blocks/boton-cotizar.liquid).
// En una ficha: abre el panel y, al enviar, arma el mensaje con la variante elegida, la cantidad,
// opcionalmente el carrito completo, el documento, la ciudad y un comentario. Recuerda los datos del
// cliente en su navegador. Fuera de una ficha: abre WhatsApp con el mensaje inicial y las preguntas.

const pesos = (n) => '$' + Math.round(n).toLocaleString('es-CL');
const CLAVE = 'toolstore-cotizar';

const leer = () => {
  try { return JSON.parse(localStorage.getItem(CLAVE)) || {}; } catch (e) { return {}; }
};
const guardar = (datos) => {
  try { localStorage.setItem(CLAVE, JSON.stringify(datos)); } catch (e) {}
};

class CotizarWhatsapp extends HTMLElement {
  connectedCallback() {
    if (this.listo) return;
    this.listo = true;
    this.panel = this.querySelector('.cotizar-wsp__panel');
    const datos = this.querySelector('script[data-variantes]');
    this.variantes = datos ? JSON.parse(datos.textContent) : null;
    this.carrito = [];

    this.querySelector('[data-abrir]').addEventListener('click', () => {
      if (!this.panel) {
        const cierre = (this.dataset.cierre || '').trim();
        this.abrirWhatsapp(this.dataset.mensaje + (cierre ? '\n\n' + cierre : ''), {});
        return;
      }
      const abierto = !this.panel.hidden;
      this.panel.hidden = abierto;
      this.querySelector('[data-abrir]').setAttribute('aria-expanded', String(!abierto));
      if (!abierto) {
        this.prepararPanel();
        this.publicar('cotizar_whatsapp_panel', this.seleccion());
      }
    });

    if (!this.panel) return;
    this.restaurar();
    this.panel.addEventListener('change', (e) => {
      if (e.target.type === 'radio') this.mostrarFactura();
      if (e.target.matches('[data-retiro]')) this.panel.querySelector('[data-comuna]').disabled = e.target.checked;
    });
    this.panel.querySelector('[data-enviar]').addEventListener('click', () => {
      const r = this.seleccion();
      const texto = this.mensaje(r);
      this.recordar();
      this.abrirWhatsapp(texto, r);
    });
  }

  // Al abrir: copia la cantidad de la ficha y revisa si hay otros productos en el carrito.
  prepararPanel() {
    const form = document.querySelector('form[action*="/cart/add"]');
    const q = parseInt(form?.querySelector('[name="quantity"]')?.value, 10);
    if (q > 0) this.panel.querySelector('[data-cantidad]').value = q;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const actual = this.seleccion().id;
        this.carrito = (cart.items || []).filter((i) => String(i.variant_id) !== String(actual));
        const fila = this.panel.querySelector('[data-carrito-fila]');
        const n = this.carrito.length;
        fila.hidden = n === 0;
        fila.querySelector('[data-carrito-texto]').textContent =
          'Incluir también lo que tengo en el carrito (' + n + (n === 1 ? ' producto)' : ' productos)');
      })
      .catch(() => {});
  }

  mostrarFactura() {
    const doc = this.panel.querySelector('input[type="radio"]:checked')?.value;
    this.panel.querySelector('[data-factura]').hidden = doc !== 'Factura';
  }

  restaurar() {
    const d = leer();
    if (d.doc) {
      const radio = this.panel.querySelector('input[type="radio"][value="' + d.doc + '"]');
      if (radio) radio.checked = true;
    }
    if (d.rut) this.panel.querySelector('[data-rut]').value = d.rut;
    if (d.ciudad) this.panel.querySelector('[data-comuna]').value = d.ciudad;
    if (d.retiro) {
      this.panel.querySelector('[data-retiro]').checked = true;
      this.panel.querySelector('[data-comuna]').disabled = true;
    }
    if (d.formal) this.panel.querySelector('[data-formal]').checked = true;
    this.mostrarFactura();
  }

  recordar() {
    guardar({
      doc: this.panel.querySelector('input[type="radio"]:checked')?.value,
      rut: this.panel.querySelector('[data-rut]').value.trim(),
      ciudad: this.panel.querySelector('[data-comuna]').value.trim(),
      retiro: this.panel.querySelector('[data-retiro]').checked,
      formal: this.panel.querySelector('[data-formal]').checked,
    });
  }

  // Variante elegida en la ficha y cantidad del panel.
  seleccion() {
    const form = document.querySelector('form[action*="/cart/add"]');
    const id = form?.querySelector('[name="id"]')?.value;
    const ids = Object.keys(this.variantes || {});
    const varId = id && this.variantes?.[id] ? id : ids[0];
    const v = (this.variantes && this.variantes[varId]) || {};
    const campo = this.panel?.querySelector('[data-cantidad]');
    const cantidad = Math.max(1, parseInt(campo?.value, 10) || 1);
    return { id: varId, variante: v.t, sku: v.s, precio: (v.p || 0) / 100, cantidad };
  }

  mensaje(r) {
    const d = this.dataset;
    const lineas = [d.mensaje, '• ' + d.producto];
    const detalle = [];
    if (d.sinVariantes !== 'true' && r.variante) detalle.push(r.variante);
    if (r.sku) detalle.push('SKU ' + r.sku);
    if (detalle.length) lineas.push('  ' + detalle.join(' · '));
    let cant = '  Cantidad: ' + r.cantidad;
    if (r.precio) {
      cant += ' (precio web ' + pesos(r.precio) + ' c/u';
      cant += r.cantidad > 1 ? ' = ' + pesos(r.precio * r.cantidad) + ')' : ')';
    }
    lineas.push(cant);
    lineas.push('  ' + d.tienda + d.url + (r.id ? '?variant=' + r.id : ''));

    let total = r.precio * r.cantidad;
    r.productos = 1;
    if (this.panel.querySelector('[data-carrito]').checked && this.carrito.length) {
      lineas.push('', 'Además, de mi carrito:');
      for (const i of this.carrito) {
        const partes = [i.product_title];
        if (i.variant_title && i.variant_title !== 'Default Title') partes.push(i.variant_title);
        if (i.sku) partes.push('SKU ' + i.sku);
        lineas.push('• ' + partes.join(' · ') + ' · Cantidad: ' + i.quantity + ' (' + pesos(i.final_line_price / 100) + ')');
        total += i.final_line_price / 100;
      }
      r.productos += this.carrito.length;
      lineas.push('Total aproximado a precio web: ' + pesos(total));
    }

    const doc = this.panel.querySelector('input[type="radio"]:checked')?.value || 'Boleta';
    lineas.push('', 'Documento: ' + doc);
    if (doc === 'Factura') {
      const rut = this.panel.querySelector('[data-rut]').value.trim();
      lineas.push('RUT y razón social: ' + (rut || '(por completar)'));
    }
    if (this.panel.querySelector('[data-formal]').checked) lineas.push('Cotización formal: sí');
    const retiro = this.panel.querySelector('[data-retiro]').checked;
    const ciudad = this.panel.querySelector('[data-comuna]').value.trim();
    lineas.push(retiro ? 'Entrega: retiro en tienda' : 'Despacho a: ' + (ciudad || '(ciudad por completar)'));
    const comentario = this.panel.querySelector('[data-comentario]').value.trim();
    if (comentario) lineas.push('Comentario: ' + comentario);

    r.documento = doc;
    r.entrega = retiro ? 'retiro' : 'despacho';
    r.total = total;
    return lineas.join('\n');
  }

  abrirWhatsapp(texto, datos) {
    const url = 'https://wa.me/' + this.dataset.telefono + '?text=' + encodeURIComponent(texto);
    this.publicar('cotizar_whatsapp', datos);
    window.open(url, '_blank', 'noopener');
  }

  // Medición: evento propio de Shopify (lo leen los píxeles personalizados) y, si están presentes
  // en la página, GA4 y Meta.
  publicar(nombre, datos) {
    const info = {
      producto: this.dataset.producto || null,
      variante_id: datos?.id || null,
      sku: datos?.sku || null,
      cantidad: datos?.cantidad || null,
      productos: datos?.productos || null,
      valor: datos?.total || (datos?.precio ? datos.precio * (datos.cantidad || 1) : null),
      documento: datos?.documento || null,
      entrega: datos?.entrega || null,
    };
    try { window.Shopify?.analytics?.publish?.(nombre, info); } catch (e) {}
    if (nombre !== 'cotizar_whatsapp') return;
    try {
      window.gtag?.('event', 'generate_lead', { method: 'whatsapp', currency: 'CLP', value: info.valor || 0, items: info.sku ? [{ item_id: info.sku, item_name: info.producto, quantity: info.cantidad }] : [] });
    } catch (e) {}
    try { window.fbq?.('track', 'Contact', { content_name: info.producto, content_ids: info.sku ? [info.sku] : [] }); } catch (e) {}
  }
}

if (!customElements.get('cotizar-whatsapp')) customElements.define('cotizar-whatsapp', CotizarWhatsapp);
